import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { amplifyConfig } from './amplify-config';
import { SpaKeyValueStorage } from './spa-key-value-storage';

export function amplifyInitializer(): () => void {
  return (): void => {
    Amplify.configure(amplifyConfig);
    cognitoUserPoolsTokenProvider.setKeyValueStorage(
      new SpaKeyValueStorage('rep:amp:')
    );
  };
}
